if (!customElements.get('product-carousel-overlay')) {
  class ProductCarouselOverlay extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('button[command="show-modal"]');
      this.closeButton = this.querySelector('button[command="close"]');
      this.prevButton = this.querySelector('.product-carousel-overlay__featured-media-cont button[aria-label="previous"]');
      this.nextButton = this.querySelector('.product-carousel-overlay__featured-media-cont button[aria-label="next"]');
      this.thumbnails = Array.from(this.querySelectorAll('.product-carousel-overlay__media-thumbnails > *'));
      this.featMedias = Array.from(this.querySelectorAll('.product-carousel-overlay__featured-media > *'));
      this.activeIndex = 0;
      this.lastIndex = this.featMedias.length - 1;
      this.handleOpenClick = this.handleOpenClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handlePrevClick = this.handlePrevClick.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);
      this.handleThumbnailClick = this.handleThumbnailClick.bind(this);

      this.closeButton.addEventListener('click', this.handleCloseClick);
      this.openButton.addEventListener('click', this.handleOpenClick);
      this.prevButton.addEventListener('click', this.handlePrevClick);
      this.nextButton.addEventListener('click', this.handleNextClick);
      this.thumbnails.forEach(ele => ele.addEventListener('click', this.handleThumbnailClick));
    }

    disconnectedCallback() {
      this.dialog.removeEventListener('click', this.handleCloseClick);
      this.openButton.removeEventListener('click', this.handleOpenClick);
      this.prevButton.removeEventListener('click', this.handlePrevClick);
      this.nextButton.removeEventListener('click', this.handleNextClick);
      this.thumbnails.forEach(ele => ele.removeEventListener('click', this.handleThumbnailClick));
    }

    handleOpenClick(event) {
      event.preventDefault();

      this.dialog.showModal();
      setTimeout(() => this.dialog.classList.add('opening'));
    }

    handleCloseClick(event) {
      event.preventDefault();
      this.dialog.classList.remove('opening');

      this.dialog.addEventListener('transitionend', () => {
        this.dialog.close();
      }, {once: true})
    }

    handlePrevClick() {
      if (this.activeIndex > 0) {
        this.nextButton.disabled = false;
        this.featMedias.forEach(ele => ele.classList.remove('active'));
        this.featMedias[this.activeIndex - 1].classList.add('active');

        this.thumbnails.forEach(ele => ele.classList.remove('active'));
        this.thumbnails[this.activeIndex - 1].classList.add('active');
        this.thumbnails[this.activeIndex - 1].scrollIntoView({block: 'center', container: 'nearest', behavior: 'smooth'});

        this.activeIndex = this.activeIndex - 1;
      } else {
        this.prevButton.disabled = true;
      }
    }

    handleNextClick() {
      if (this.activeIndex < this.lastIndex) {
        this.prevButton.disabled = false;
        this.featMedias.forEach(ele => ele.classList.remove('active'));
        this.featMedias[this.activeIndex + 1].classList.add('active');

        this.thumbnails.forEach(ele => ele.classList.remove('active'));
        this.thumbnails[this.activeIndex + 1].classList.add('active');
        this.thumbnails[this.activeIndex + 1].scrollIntoView({block: 'center', container: 'nearest', behavior: 'smooth'});

        this.activeIndex = this.activeIndex + 1;
      } else {
        this.nextButton.disabled = true;
      }
    }

    handleThumbnailClick(event) {
      this.activeIndex = this.thumbnails.indexOf(event.currentTarget);

      this.featMedias.forEach(ele => ele.classList.remove('active'));
      this.featMedias[this.activeIndex].classList.add('active');

      this.thumbnails.forEach(ele => ele.classList.remove('active'));
      this.thumbnails[this.activeIndex].classList.add('active');
      this.thumbnails[this.activeIndex].scrollIntoView({block: 'center', container: 'nearest', behavior: 'smooth'});
    }
  }
  
  customElements.define('product-carousel-overlay', ProductCarouselOverlay);
}
